module.exports = require('react-router-dom');